export const navItems = [
  {
    key: 'autopilot',
    desktop: 'HR Autopilot',
    tablet: 'HR Autopilot',
  },
  {
    key: 'manager',
    desktop: 'HR Manager',
    tablet: 'HR Manager',
  },
  {
    key: 'about',
    desktop: 'Who We Are',
    tablet: 'About',
  },
  {
    key: 'resources',
    desktop: 'Resources',
    tablet: 'Resources',
  },
];

// Homepage nav (BIO-2150). Each item is a link to a section below the hero;
// the sections exist on the homepage only, so HomeNav prefixes `/` elsewhere.
export const fauxNavItems = [
  {
    desktop: 'Continuous Compliance™',
    subtitle: '& Stay Compliant',
    anchor: 'compliance',
  },
  {
    desktop: 'Company Coverage™',
    subtitle: '& See Everything',
    anchor: 'coverage',
  },
  {
    desktop: 'Organizational Matters™',
    subtitle: '& Nothing Slips Through',
    anchor: 'matters',
  },
  {
    desktop: 'Dedicated HR Manager™',
    subtitle: '& Meet Goals',
    anchor: 'plans',
  },
];

export const HeroContent = {
  title: `Put your HR on Autopilot`,
  subtitle: `plus a Dedicated HR Manager for $9/mo`,
  benefits: [
    { text: `Your Own Dedicated HR Manager` },
    { text: `HR Compliant Policies` },
    { text: `Employee Onboarding & Terminations` },
    { text: `Relief From Complex HR Issues` },
    { text: `Annual & Comprehensive HR Audits` },
    { text: `$9/mo for companies up to 500 employees` },
    { text: `Work Off Your Plate & Peace of Mind!` },
  ],
};

export const Automations = [
  {
    id: 'autopilot-audit',
    image: '/assets/images/market/autopilot-identify.svg',
    header: '01 HR AUDITS',
    title: 'Quickly Identify Your HR Gaps',
    body: `HR rules change. Audits let you identify any HR gaps, and then we help you with an action plan to get your internal practices up-to-date to keep protecting your company and employees.`,
  },
  {
    id: 'autopilot-policy',
    image: '/assets/images/market/preview-policy.webp',
    header: '02 HR POLICIES',
    title: 'Policies That Protect Your Business and Standardize Your Culture',
    body: `HR Autopilot makes sure all core, protective policies are current, signed by your employees, and reaffirmed semi-annually.  Then, your dedicated HR Manager crafts any custom HR policies your business needs.`,
  },
  {
    id: 'autopilot-training',
    image: '/assets/images/market/autopilot-training.webp',
    header: '03 TRAINING & CERTIFICATIONS',
    title: 'Training That Keeps Your Staff Compliant and Productive',
    body: `Bambee takes care of important and often-mandatory training like sexual harassment, workplace safety, and business ethics - and reports back to you on everyone’s progress.`,
  },
  {
    id: 'autopilot-reportcard',
    image: '/assets/images/market/autopilot-reportcard.webp',
    header: '04 STAFF PERFORMANCE TRACKING',
    title: 'Deliver Feedback to Improve Employee Performance',
    body: `Bambee’s Report Cards help you track your staff against their goals, and open up a regular dialogue to give praise, constructive feedback, or take corrective action.`,
  },
  {
    id: 'autopilot-voices',
    image: '/assets/images/market/autopilot-voices.webp',
    header: '05 UNDERSTAND EMPLOYEE MORALE',
    title: 'Create A Space For Employees to Speak Their Thoughts',
    body: `Employee Voices lets your employees share concerns and alert you to potential problems.  But it doesn’t have to be bad news - it’s also a great way for your staff to express gratitude, anonymously or publicly.`,
  },
  {
    id: 'autopilot-cabinet',
    image: '/assets/images/market/autopilot-signature.webp',
    header: '06 COMPLIANT DOCUMENT STORAGE',
    title: 'Comply with EEOC Document Retention Standards',
    body: `Federal & state laws mandate that certain company files be held for a certain period of time.  Plus, never guess who signed what - or where your important HR documents are.  They’re all gathered safely in your Smart Cabinet.`,
  },
];

export const DedicatedHrList = [
  {
    icon: 'doorOpenSolid',
    title: 'Employee Relations & HR Problem Solving',
    body: 'The most sensitive issues require rich dialogue.  Your HR Manager engages with you to create the right outcomes for your business.',
  },
  {
    icon: 'clipboardCheckSolid',
    title: 'Craft HR Policies, Procedures & Shape Company Culture',
    body: 'Your HR Manager builds policies specific for your businesses based on labor regulation and your unique company culture for better alignment.',
  },
  {
    icon: 'badgeDollarSolid',
    title: 'Onboarding, Terminations & Navigating Labor Regulations',
    body: `Lean on Bambee for onboarding, terminations, and corrective actions and get clarity on all your regulatory questions.`,
  },
  {
    icon: 'binoculars',
    title: 'Employer Coaching & Guidance',
    body: 'Your HR Manager gets to know you on a first name basis and gives you full remote HR support plus coaching where you need it.',
  },
];

export default {
  DedicatedHrList,
  HeroContent,
  navItems,
};
